function addActiveBundleToCard(selector, bundle, installed, esim, products) {
    let bundleUsage = bundle.assignment;
    let initialQuantity = bundleUsage.initialQuantity / 1000000000;
    let remainingQuantity = bundleUsage.remainingQuantity / 1000000000;
    let usedData = initialQuantity - remainingQuantity;

    //Add Plan Name and Map to Card
    if (products && products[bundle.name]) {
      if (products[bundle.name].product_map != undefined &&  products[bundle.name].product_map != '') {
        selector.querySelector('.bundle_details_map').setAttribute('src', products[bundle.name].product_map);
      }    
      selector.querySelector('.bundle_details_plan_name').innerText = products[bundle.name].product_title;
    }

    if (installed) {
      // Set Usage Progress Bar Percentage
      selector.querySelector('.usage_data_progress_progress').setAttribute('value', (usedData / initialQuantity) * 100);

      // Set Usage Heading Text
      if (usedData.toFixed(2) > 999) {
        usedData = usedData / 1000;
        selector.querySelector('.usage_data_progress_heading').innerText = usedData.toFixed(2) + esimCardTranslations.gb_of + " " + initialQuantity + esimCardTranslations.gb_used;
      } else {
        usedData = usedData * 1000;
        selector.querySelector('.usage_data_progress_heading').innerText = Math.round(usedData) + esimCardTranslations.mb_of + " " + initialQuantity + esimCardTranslations.gb_used;
      }

      //Set Usage Subtitle
      if (bundleUsage.remainingQuantity < 1.0) {
        selector.querySelector('.usage_data_progress_subheading').innerText = Math.round((remainingQuantity*1000)) + esimCardTranslations.mb_remaining;
      } else {
        selector.querySelector('.usage_data_progress_subheading').innerText = remainingQuantity.toFixed(1) + esimCardTranslations.gb_remaining;
      }
      
      let startTime = new Date(bundleUsage.startTime);
      let endTime = new Date(bundleUsage.endTime);
      let bundleLength = parseInt((endTime - startTime) / (1000 * 60 * 60 * 24), 10);
      let timeLeft = Math.floor((endTime - Date.now()) / (1000 * 3600 * 24));

      // Set Time Heading Text
      selector.querySelector('.remaining_days_progress_heading').innerText = bundleLength + esimCardTranslations.day_bundle_expires_prefix + timeLeft + esimCardTranslations.day_bundle_expires_suffix;

      // Set Time Progress Bar Percentage
      let exipiryBarData = Math.round(((Date.now() - startTime) / (endTime - startTime)) * 100);
      selector.querySelector('.remaining_days_progress_progress').setAttribute('value', exipiryBarData);

      //Set Time Subtitle
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let convertedTz = endTime.toLocaleString(undefined, {timeZone: tz, timeZoneName:'short'});
      selector.querySelector('.remaining_days_progress_subheading').innerText = esimCardTranslations.expires_on + convertedTz;
    }
}

function viewEsimDetails(iccid) {
    location.href= Shopify.routes.root + 'pages/esim-details/?iccid=' + iccid;
}

function findProductBySku(sku, products){
  const pattern = new RegExp(`^esim.+_${sku.split('_').slice(1, -1).join('_')}_.*`);
  return Object.entries(products).find(
    ([key, value]) => pattern.test(key)
  )?.[0] || null;
}